import React, {useContext} from 'react'
import {Query} from 'react-apollo'
import {companyLogo} from '../../graphql/barcode/queries/companyLogoQuery'
import {BarcodeUserSettingsContext} from '../../context/BarcodeUserSettings'

function BarcodeLabelCompanyLogo(props) {
  const {userSettings} = useContext(BarcodeUserSettingsContext)
  const [url, setUrl] = React.useState(props.item.image || null)

  return (
    <React.Fragment>
      {!url && (
        <Query
          query={companyLogo}
          variables={{
            accountId: parseInt(userSettings.id),
            token: userSettings.token,
          }}
          onCompleted={data =>
            setUrl(
              process.env.REACT_APP_CLOUDFRONT_URL +
                'uploads' +
                data.companyLogo.url.split('uploads', 2)[1]
            )
          }
          fetchPolicy="network-only"
        >
          {({loading, error, data}) => {
            return null
          }}
        </Query>
      )}
      <div className={props.className} style={{backgroundImage: `url(${url})`}}></div>
    </React.Fragment>
  )
}

export default BarcodeLabelCompanyLogo
